import axios from '@/store/axios.factory'

class ArrecadacaoCategoriaService {
    arrecadacaocategoria () {
    return axios.get(`/v1/arrecadacaocategoria/listar`)
  }

  arrecadacaocategoria () {
    return axios.get(`/v1/arrecadacaocategoria/listar-parametrizadas`)
  }
}

export const arrecadacaoCategoriaService = new ArrecadacaoCategoriaService()
